import * as React from "react";

export class InconsistenciaSarlaftForm extends React.Component {

    componentWillMount() {

    }

    componentDidMount() {
    }

    render() {

        return (
            <div/>
        )
    }

    validate = (values: any) => {
    };

    onSubmit = (values: any) => {
    };
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sarlaft/insconsistencias/componentes/InconsistenciasForm.tsx